import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_collections, use_slice_generation, use_slice_search } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_child_entity_share_status_update } from '@/state/workspace/child_entity/remote_workspace_child_entity_share_status_update';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { RequestWorkspaceChildEntityUpdateShareStatus } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_update_share_status';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function ButtonWorkspaceStopSharing() {
  const dispatch = use_dispatch();
  const { toast } = useToast();

  const { collections_map } = use_slice_collections(['collections_map']);
  const { user_tasks_map } = use_slice_generation(['user_tasks_map']);
  const { search_history_map } = use_slice_search(['search_history_map']);

  const { t } = useTranslation([ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE, ENUM__i18n_namespace.BASE_UI]);

  const is_disabled = useMemo(() => {
    return get_is_disabled();
  }, [collections_map, user_tasks_map, search_history_map]);

  /*
   * EFFECTS
   */

  function get_is_disabled() {
    let is_any_collection_shared = Array.from(collections_map.values()).filter(item => item.is_shared).length > 0;
    let is_any_flow_shared = Array.from(user_tasks_map.values()).filter(item => item.is_shared).length > 0;
    let is_any_search_shared = Array.from(search_history_map.values()).filter(item => item.is_shared).length > 0;

    return !is_any_collection_shared && !is_any_flow_shared && !is_any_search_shared;
  }

  /*
   * EVENTS
   */

  async function onClick() {
    let shared_entities: DTO__workspace_child_enity[] = [];

    shared_entities = [...shared_entities, ...Array.from(collections_map.values().filter(item => item.is_shared))];
    shared_entities = [...shared_entities, ...Array.from(user_tasks_map.values().filter(item => item.is_shared))];
    shared_entities = [...shared_entities, ...Array.from(search_history_map.values().filter(item => item.is_shared))];

    let requests = [];

    for (let entity of shared_entities) {
      let request = new RequestWorkspaceChildEntityUpdateShareStatus();
      request.workspace_id = entity.workspace_id;
      request.entity_type = entity.type;
      request.entity_id = entity._id;
      request.is_shared = false;

      requests.push(request);
    }

    await dispatch(remote_workspace_child_entity_share_status_update(requests));

    toast({ title: t(i18n_base_ui.toasts.butto_wWorkspace_stop_sharing.title) });
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__button className="min-w-48 px-4" variant="outline-on-component" {...{ onClick }} disabled={is_disabled}>
      <span className="text-danger">{t(i18n_page_settings_workspace.tabs.shared_entities.button.stop_sharing_all)}</span>
    </UI_PRIMITIVE__button>
  );
}
